import '../App.css';
import { useState, useEffect, useContext } from 'react';

import * as fcl from '@onflow/fcl';
import * as t from '@onflow/types';

import { mintTokensTx } from "../cadence/mint_tokens.js";
import { getBalanceScript } from "../cadence/get_balance.js";

import FlowContext from '../context/FlowContext';

const Mint = () => {
  const flow = useContext(FlowContext);
  const [loading, setLoading] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [balance, setBalance] = useState();

  const mintTokens = async () => {

    setLoading("Initializing transaction...");
    const transactionId = await fcl.send([
      fcl.transaction(mintTokensTx),
      fcl.args([]),
      fcl.proposer(fcl.authz),
      fcl.payer(fcl.authz),
      fcl.authorizations([fcl.authz]),
      fcl.limit(9999)
    ]).then(fcl.decode);

    setLoading("Please wait ~20 seconds for the tokens to be in your account.");
    setTransactionId(transactionId);
    await fcl.tx(transactionId).onceSealed();
    setLoading('');
    setTransactionId('');
  }

  const getBalance = async () => {
    const result = await fcl.send([
      fcl.script(getBalanceScript),
      fcl.args([
        fcl.arg(flow.user.addr, t.Address)
      ])
    ]).then(fcl.decode);

    setBalance(parseInt(result));
  }

  useEffect(() => {
    if (flow.user && flow.user.addr) {
      try {
        getBalance();
      } catch (e) {
        setBalance(0);
      }
    }
    console.log(flow.user)
  }, [flow.user, transactionId])

  return (
    <div className="App">

      {!flow.user.loggedIn
        ?
        <h1>Mint your testnet <span style={{ color: "lightgreen" }}>Emerald Beta</span> tokens by logging in.</h1>
        : flow.user.loggedIn && balance !== 5 && transactionId === ''
          ? <h1>Click the button below to mint <span style={{ color: "lightgreen" }}>Emerald Beta</span> tokens.</h1>
          : flow.user.loggedIn && balance === 5
            ?
            <div className="done-minting">
              <h1>You successfully completed the minting process ^_^</h1>
              <h2>Balance: {balance}</h2>
            </div>
            : null
      }

      {loading !== '' ? <h1>{loading}</h1> : null}

      {flow.user.loggedIn && balance !== 5 && transactionId !== ''
        ?
        <a href={`https://testnet.flowscan.org/transaction/${transactionId}`} target="_blank" rel="noreferrer" className="transaction-link green">
          View your Transaction
        </a>
        : flow.user.loggedIn && balance !== 5
          ? <button className="button-9 green" onClick={() => mintTokens()}>Mint</button>
          : null
      }
    </div>
  );
}

export default Mint;
